import { stripUnit } from 'polished';

export const appHeaderHeight = '48px';
export const pageToolbarHeight = '48px';
export const dropdownSideSpacing = '20px';
export const sectionWidth = '1024px';

export const appSideSpacing = `${stripUnit(dropdownSideSpacing) + 20}px`;
